import { Button, Flex } from 'pcln-design-system';
import React, { useContext, useState } from 'react';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { QuickActionsStackVariant } from './chatTypes';
import styled from 'styled-components';
import analytics from './analytics';
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "QuickActions__StyledFlex",
  componentId: "sc-15h2wre-0"
})(["", ""], props => props.isQuickActionsHorizontalStack && 'overflow: auto;');
const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "QuickActions__StyledButton",
  componentId: "sc-15h2wre-1"
})(["", ""], props => props.isQuickActionsHorizontalStack && 'white-space: nowrap;');
export const QuickActions = props => {
  const {
    submitQuickActionMessage,
    hasOtherMessage,
    quickActions
  } = props;
  const [isQuickActionsDisplayed, setQuickActionsDisplayedValue] = useState(true);
  const {
    isMobile,
    quickActionsStackVariant
  } = useContext(ChatbotDataContext);
  const isQuickActionsHorizontalStack = quickActionsStackVariant === QuickActionsStackVariant.HORIZONTAL;
  if (!quickActions.length || hasOtherMessage || !isQuickActionsDisplayed) {
    return null;
  }
  return React.createElement(StyledFlex, {
    flexDirection: isQuickActionsHorizontalStack ? 'row' : 'column',
    alignItems: 'center',
    p: 2,
    flexWrap: isQuickActionsHorizontalStack ? 'nowrap' : 'wrap',
    isQuickActionsHorizontalStack: isQuickActionsHorizontalStack
  }, quickActions.map((action, i) => React.createElement(Flex, {
    key: `quick-action-button-${i}`,
    my: 2,
    mx: 1,
    alignItems: 'center',
    width: isMobile ? 1 : ''
  }, React.createElement(StyledButton, {
    boxShadowSize: 'sm',
    variation: 'white',
    onClick: function () {
      submitQuickActionMessage(action);
      setQuickActionsDisplayedValue(false);
      analytics.log({
        label: 'quickActions',
        message: 'QUICK_ACTION_BUTTON_CLICKED',
        content: action.label
      });
    },
    width: isMobile ? 1 : '',
    isQuickActionsHorizontalStack: isQuickActionsHorizontalStack
  }, action.label))));
};